export const CROSS_PROMO_FROM_LEVEL_NUMBER = 20;

export const DEBUG_X_PROMO_CAMPAIGNS: unknown[] = [
    {
        id: 49,
        name: '[DO NOT DISABLE] - The Blank Campaign',
        targetedApp: { name: 'Trivia Quiz', id: '365241137646663' },
        placeholder: 'no_interstitial_ad',
        assets: [
            {
                language: 'en',
                type: 'portrait',
                src:
                    'https://d3d40s6u63df5a.cloudfront.net/assets/1578569249414-trivia_quiz_square_EN.png',
            },
            {
                language: 'default',
                type: 'portrait',
                src:
                    'https://d3d40s6u63df5a.cloudfront.net/assets/1578569249414-trivia_quiz_square_EN.png',
            },
            {
                language: 'en',
                type: 'portrait',
                src:
                    'https://d3d40s6u63df5a.cloudfront.net/assets/1580477594761-A2U_SOFA_1.png',
            },
        ],
        userTargeting: [],
    },
    {
        id: 50,
        name: '[DO NOT DISABLE] - Test Campaign - icon_picture_combo',
        targetedApp: { name: 'Garden Tales', id: '243759199843609' },
        placeholder: 'icon_picture_combo',
        assets: [
            {
                language: 'en',
                type: 'icon',
                src:
                    'https://d3d40s6u63df5a.cloudfront.net/assets/1581514560799-tales_gardentales_icon.png',
            },
            {
                language: 'default',
                type: 'icon',
                src:
                    'https://d3d40s6u63df5a.cloudfront.net/assets/1581514560799-tales_gardentales_icon.png',
            },
            {
                language: 'en',
                type: 'landscape',
                src:
                    'https://d3d40s6u63df5a.cloudfront.net/assets/1581514561756-tales_landscapeimage1.png',
            },
            {
                language: 'default',
                type: 'landscape',
                src:
                    'https://d3d40s6u63df5a.cloudfront.net/assets/1581514561756-tales_landscapeimage1.png',
            },
            {
                language: 'en',
                type: 'portrait',
                src:
                    'https://d3d40s6u63df5a.cloudfront.net/assets/1581514562017-tales_portraitimage1.png',
            },
            {
                language: 'default',
                type: 'portrait',
                src:
                    'https://d3d40s6u63df5a.cloudfront.net/assets/1581514562017-tales_portraitimage1.png',
            },
        ],
        userTargeting: [],
    },
];